
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28618',
  depVersions: {
  "payments-ui-app": "static-1.28618",
  "bend-plugin-arboretum": "static-1.1973",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "crm_data": "static-4.93106",
  "data-fetching-client": "static-1.10076",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8677",
  "foundations-components-legacy": "static-1.1702",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6019",
  "hs-test-utils": "static-1.8468",
  "hub-http": "static-1.6639",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11922",
  "I18n": "static-7.1698",
  "jasmine-runner": "static-1.6881",
  "quartz": "static-1.7606",
  "raven": "static-3.5925",
  "react-dlb": "static-1.92",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.119",
  "react-utils": "static-2.5635",
  "reselect": "static-3.15",
  "stripe-js": "static-1.118",
  "ui-components-test-utils": "static-1.6059",
  "UIComponents": "static-3.8868",
  "usage-tracker-public": "static-1.7555",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38015",
  "payments-checkout-lib": "static-1.541",
  "cssUtils": "static-1.1052",
  "customer-data-objects": "static-1.8124",
  "FireAlarmUi": "static-1.4816",
  "foundations-assets": "static-1.5316",
  "foundations-theming": "static-1.4913",
  "graphql": "static-1.92",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12229",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3316",
  "property-translator": "static-1.5809",
  "quartz-config": "static-1.1384",
  "quartz-core": "static-1.6825",
  "quartz-i18n": "static-1.1281",
  "quartz-routing": "static-1.1036",
  "quartz-tracking": "static-1.985",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17164",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "ReduxMessenger": "static-2.10802",
  "rpc-client-utils": "static-1.5100",
  "sanitize-text": "static-1.8586",
  "SharedI18nStrings": "static-1.186",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5188",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11576",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7594",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3883",
  "quartz-webpack": "static-1.3830",
  "bend-plugin-quartz-routing": "static-1.684",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22657",
  "customer-data-email": "static-1.18591",
  "customer-data-ui-utilities": "static-1.10263",
  "dispatcher": "static-1.146",
  "frontend-preferences-client": "static-1.8348",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8193",
  "quick-fetch": "static-1.4203",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4946",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2629",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9854",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2980",
  "ui-fonts": "static-1.1184",
  "HeadJS": "static-2.816",
  "hs-test-utils-bend-plugin": "static-1.3579",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.373",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4738",
  "foundations-components-test-utils": "static-1.6160",
  "ui-addon-draggable": "static-3.5177",
  "commerce-billing-lib": "static-1.20456",
  "commerce-shared-components-lib": "static-1.19489",
  "commerce-tools-ui-lib": "static-1.11248",
  "crm-message-bus": "static-1.44009",
  "customer-data-objects-ui-components": "static-1.13460",
  "customer-data-properties": "static-1.52928",
  "growth-payments-core": "static-1.26421",
  "ui-addon-iframeable": "static-1.9506",
  "usage-tracker": "static-1.7744",
  "usage-tracker-container": "static-1.7734",
  "sassPrefix": "static-1.319",
  "inbound-db-properties-service-client": "static-1.4120",
  "foundations-theming-base": "static-1.3898",
  "bend-plugin-foundations-theming": "static-1.3396",
  "stylex": "static-1.45",
  "opentelemetry-fe-types": "static-1.217",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4943",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.592",
  "quartz-auth": "static-1.1281",
  "quartz-head": "static-1.1271",
  "quartz-test": "static-1.1281",
  "trellis-components": "static-1.2999",
  "usage-tracker-session-replay": "static-1.5430",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "immer": "static-1.104",
  "bend-plugin-chirp-manifest": "static-1.510",
  "chirp-fetch": "static-1.2331",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4903",
  "FormUrlGenerator": "static-2.5144",
  "sequences-lib": "static-1.8702",
  "apollo-link-hub-http": "static-2.5022",
  "FileManagerCore": "static-1.40263",
  "FileManagerLib": "static-1.40404",
  "hubspot-apollo-client": "static-1.5308",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.687",
  "timezone-utils": "static-2.5661",
  "ui-gdpr-components": "static-1.10651",
  "react-dnd-compat": "static-1.5040",
  "stylex-utils": "static-1.166",
  "trellis-theming": "static-1.1416",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2914",
  "hs-resources": "static-1.627",
  "pulse": "static-1.1072",
  "utility-belt": "static-1.2965",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1976",
  "customer-data-associations": "static-1.7762",
  "customer-data-property-utils": "static-1.8475",
  "customer-data-tracking": "static-1.7302",
  "framework-data-schema-resolvers": "static-1.7322",
  "framework-data-table": "static-2.12769",
  "object-builder-ui-client": "static-1.49954",
  "payments-enrollment-embed-lib": "static-1.24120",
  "stripe-embedded-components": "static-1.8174",
  "ui-addon-opt": "static-4.8813",
  "ai-components-ui-library": "static-1.9945",
  "customer-data-rte": "static-1.33827",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24764",
  "growth-onboarding-confetti": "static-1.3493",
  "growth-onboarding-empty-states": "static-1.6464",
  "hubspot-prosemirror": "static-1.19207",
  "InboxConnectUtils": "static-4.15770",
  "payment-link-components": "static-1.24367",
  "payments-post-enroll-local-storage-lib": "static-1.5533",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39104",
  "react-colorpicker": "static-2.10642",
  "ui-addon-upgrades": "static-9.18521",
  "ui-addon-video-player": "static-1.9057",
  "user-context": "static-1.5481",
  "restore-request-side-panel-lib": "static-1.1942",
  "atom": "static-1.5507",
  "reference-resolvers": "static-1.8608",
  "calling-global-api": "static-1.66055",
  "calling-internal-common": "static-1.31754",
  "calling-lifecycle-internal": "static-1.67437",
  "calling-lifecycle-messages": "static-1.59730",
  "commerce-products-lib": "static-1.10789",
  "conditional-properties-service-client": "static-1.4093",
  "crm-index-visualization-core": "static-1.4696",
  "crm-links": "static-1.6735",
  "crm-pipelines-api-client-types": "static-1.4424",
  "customer-data-properties-shared-msw-handlers": "static-1.10154",
  "external-options-client-types": "static-1.4422",
  "formula-editor": "static-1.14950",
  "google-libphonenumber": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3751",
  "inbounddb-objects-service-types": "static-1.4503",
  "meetings-icalendar-utils-lib": "static-1.1068",
  "multi-currency-client-types": "static-1.3989",
  "pipeline-validation-client-types": "static-1.4261",
  "property-value-citations": "static-1.3542",
  "reference-resolvers-lite": "static-1.8536",
  "smart-data-capture-core": "static-1.386",
  "smart-property-lib": "static-1.8549",
  "tiered-pricing": "static-1.2162",
  "topics-actions-lib": "static-1.605",
  "trellis-ext-i18n": "static-1.1317",
  "trial-components-library": "static-1.14306",
  "ui-addon-form-validation": "static-1.11341",
  "laboratory-lib": "static-3.7580",
  "onboarding-scopes": "static-1.6882",
  "seat-types-lib": "static-1.968",
  "magpie-lib": "static-1.5866",
  "navigation-messaging": "static-1.8411",
  "ts-schema": "static-1.4373",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.130",
  "hub-http-shared-msw-handlers": "static-1.10827",
  "hubspotter-http-shared-msw-handlers": "static-1.10825",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8559",
  "breeze-artifacts-sdk": "static-1.733",
  "copilot-toolkit": "static-1.12068",
  "audio-components": "static-1.6507",
  "ContentUtils": "static-1.69377",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29993",
  "FileManagerImages": "static-1.37915",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4571",
  "ui-universal-auth": "static-1.9643",
  "urlinator": "static-1.4946",
  "video-components": "static-1.14357",
  "video-data-lib": "static-1.36013",
  "video-embed": "static-1.36847",
  "hubspot-apollo-cache": "static-1.767",
  "event-emitter": "static-1.1391",
  "framework-builder-read-service-client": "static-1.4303",
  "fdsr-migration-layer": "static-1.441",
  "bend-plugin-pulse": "static-1.575",
  "fast-json-patch": "static-1.73",
  "framework-data-schema-quick-fetch": "static-1.7227",
  "persist-promise": "static-1.4133",
  "customer-data-reference-ui-components": "static-1.13597",
  "tasks-actions-lib": "static-1.353",
  "reporting-data": "static-1.69223",
  "purchase-motions-components": "static-1.6577",
  "growth-onboarding-feedback-components": "static-1.7012",
  "growth-onboarding-reliability": "static-1.5512",
  "marketplace-ui-apps-core": "static-1.19508",
  "onboarding-tours": "static-1.17329",
  "stripe-connect-js": "static-1.81",
  "chatspot-core": "static-1.23579",
  "content-assistance-lib": "static-1.8358",
  "draft-content-plugins": "static-1.29085",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22289",
  "rich-text-lib": "static-1.20487",
  "breeze-engine-lib": "static-1.2035",
  "poll-commands": "static-1.3904",
  "video-components-external": "static-1.12355",
  "trellis-story-utils": "static-1.4932",
  "ui-addon-react-router-dom": "static-1.9959",
  "content-media-capture": "static-1.5704",
  "knowledge-content-types": "static-1.8717",
  "ui-addon-emoji-picker": "static-1.10296",
  "ui-business-units-lib": "static-1.9525",
  "ui-shepherd-react": "static-3.10704",
  "hub-http-contrib": "static-1.3459",
  "ui-addon-sales-email": "static-1.5632",
  "commerce-tours-lib": "static-1.6797",
  "getting-started-shared-tasks": "static-1.19485",
  "sales-checkout-service-client": "static-1.3959",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18603",
  "onboarding-tours-utils": "static-1.1396",
  "calling-error-reporting": "static-1.31761",
  "shared-worker-versioning": "static-1.11472",
  "calling-usage-tracker": "static-1.6964",
  "voice-sms-access-library": "static-1.2344",
  "conversations-skeleton-state": "static-1.7602",
  "commerce-permissions": "static-1.1210",
  "products-iframe-lib": "static-1.8824",
  "products-ui-components-shared-msw-handlers": "static-1.11209",
  "crm-index-associations-lib": "static-1.6878",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10910",
  "sales-views-client-types": "static-1.4688",
  "location-customization-utils-lib": "static-1.10340",
  "bark-lib": "static-1.16961",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6318",
  "react-codemirror": "static-1.11070",
  "data-agent-kit": "static-1.833",
  "data-token-picker": "static-1.17059",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4185",
  "policy-lib": "static-1.7236",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10973",
  "embedded-academy-lib": "static-1.15891",
  "hubs-service-types": "static-1.1695",
  "navigation-components": "static-1.19084",
  "nudge-client-utils": "static-1.3341",
  "purchase-motions-api": "static-1.6580",
  "signup-constants": "static-1.19859",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5326",
  "reactive-lib": "static-1.1154",
  "simple-logging-lib": "static-1.3482",
  "nav-meta": "static-1.30721",
  "cms-field-types": "static-1.5242",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17325",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1439",
  "social-insights-client-types": "static-1.22863",
  "outpost": "static-1.4563",
  "reporting-client-types": "static-1.2794",
  "signup-ui-url-generator": "static-2.8489",
  "developer-experience-shared-components": "static-1.10968",
  "immutable-less": "static-1.5081",
  "marketplace-ui-client-types": "static-1.18383",
  "marketplace-ui-common": "static-1.20976",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4346",
  "growth-data-modal": "static-1.6067",
  "growth-onboarding-next-action-utils": "static-1.2909",
  "onboarding-tours-client": "static-1.5544",
  "ui-shepherd-tracker": "static-1.8085",
  "ui-coaching-tips": "static-1.29527",
  "breeze-engine-chat-components": "static-1.1013",
  "breeze-engine-core": "static-1.1313",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "content-media-composition-data-lib": "static-1.13508",
  "content-media-compositions": "static-2.17515",
  "media-bridge-lib": "static-1.19575",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4856",
  "calling-orchestration-schema": "static-1.37121",
  "crm-record-cards-service-types": "static-1.3842",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16591",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15351",
  "nest": "static-1.666",
  "nudge-custom-function-registry": "static-1.3098",
  "nudge-renderer-utils": "static-1.3417",
  "whisper-core-api": "static-1.7563",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14740",
  "integrations-tracking-lib": "static-1.6042",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1157",
  "apps-service-types": "static-1.4077",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8511",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1463",
  "onboarding-data-sync-lib": "static-1.2772",
  "growth-onboarding-next-action-components": "static-1.2937",
  "user-context-client": "static-1.4939",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4123",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4823",
  "trellis-ecosystem": "static-1.7787",
  "wootric-nps": "static-1.7274",
  "universal-page-editor-lib": "static-1.3439",
  "adobe-sign-auth-lib": "static-1.686",
  "ads-unified-auth-lib": "static-1.1803",
  "custom-vendor-connection-lib": "static-1.207",
  "google-sheets-integration-lib": "static-1.1254",
  "microsoft-drive-auth-lib": "static-1.415",
  "surveymonkey-integration-lib": "static-1.782",
  "slack-ui-library": "static-1.10827",
  "settings-ui-lib": "static-1.12960",
  "simple-data-table": "static-1.3753",
  "meetings-connect-utils-lib": "static-1.8046"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28618",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1973",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "crm_data": "/crm_data/static-4.93106",
  "data-fetching-client": "/data-fetching-client/static-1.10076",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8677",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1702",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6019",
  "hs-test-utils": "/hs-test-utils/static-1.8468",
  "hub-http": "/hub-http/static-1.6639",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11922",
  "I18n": "/I18n/static-7.1698",
  "jasmine-runner": "/jasmine-runner/static-1.6881",
  "quartz": "/quartz/static-1.7606",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.119",
  "react-utils": "/react-utils/static-2.5635",
  "reselect": "/reselect/static-3.15",
  "stripe-js": "/stripe-js/static-1.118",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6059",
  "UIComponents": "/UIComponents/static-3.8868",
  "usage-tracker-public": "/usage-tracker-public/static-1.7555",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38015",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.541",
  "cssUtils": "/cssUtils/static-1.1052",
  "customer-data-objects": "/customer-data-objects/static-1.8124",
  "FireAlarmUi": "/FireAlarmUi/static-1.4816",
  "foundations-assets": "/foundations-assets/static-1.5316",
  "foundations-theming": "/foundations-theming/static-1.4913",
  "graphql": "/graphql/static-1.92",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12229",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3316",
  "property-translator": "/property-translator/static-1.5809",
  "quartz-config": "/quartz-config/static-1.1384",
  "quartz-core": "/quartz-core/static-1.6825",
  "quartz-i18n": "/quartz-i18n/static-1.1281",
  "quartz-routing": "/quartz-routing/static-1.1036",
  "quartz-tracking": "/quartz-tracking/static-1.985",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17164",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10802",
  "rpc-client-utils": "/rpc-client-utils/static-1.5100",
  "sanitize-text": "/sanitize-text/static-1.8586",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5188",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11576",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7594",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3883",
  "quartz-webpack": "/quartz-webpack/static-1.3830",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.684",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22657",
  "customer-data-email": "/customer-data-email/static-1.18591",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10263",
  "dispatcher": "/dispatcher/static-1.146",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8348",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8193",
  "quick-fetch": "/quick-fetch/static-1.4203",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4946",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2629",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9854",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2980",
  "ui-fonts": "/ui-fonts/static-1.1184",
  "HeadJS": "/HeadJS/static-2.816",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3579",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.373",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4738",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6160",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5177",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20456",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19489",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11248",
  "crm-message-bus": "/crm-message-bus/static-1.44009",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13460",
  "customer-data-properties": "/customer-data-properties/static-1.52928",
  "growth-payments-core": "/growth-payments-core/static-1.26421",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9506",
  "usage-tracker": "/usage-tracker/static-1.7744",
  "usage-tracker-container": "/usage-tracker-container/static-1.7734",
  "sassPrefix": "/sassPrefix/static-1.319",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4120",
  "foundations-theming-base": "/foundations-theming-base/static-1.3898",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3396",
  "stylex": "/stylex/static-1.45",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.217",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4943",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.592",
  "quartz-auth": "/quartz-auth/static-1.1281",
  "quartz-head": "/quartz-head/static-1.1271",
  "quartz-test": "/quartz-test/static-1.1281",
  "trellis-components": "/trellis-components/static-1.2999",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5430",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "immer": "/immer/static-1.104",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.510",
  "chirp-fetch": "/chirp-fetch/static-1.2331",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4903",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5144",
  "sequences-lib": "/sequences-lib/static-1.8702",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "FileManagerCore": "/FileManagerCore/static-1.40263",
  "FileManagerLib": "/FileManagerLib/static-1.40404",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5308",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.687",
  "timezone-utils": "/timezone-utils/static-2.5661",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "react-dnd-compat": "/react-dnd-compat/static-1.5040",
  "stylex-utils": "/stylex-utils/static-1.166",
  "trellis-theming": "/trellis-theming/static-1.1416",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2914",
  "hs-resources": "/hs-resources/static-1.627",
  "pulse": "/pulse/static-1.1072",
  "utility-belt": "/utility-belt/static-1.2965",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1976",
  "customer-data-associations": "/customer-data-associations/static-1.7762",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8475",
  "customer-data-tracking": "/customer-data-tracking/static-1.7302",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7322",
  "framework-data-table": "/framework-data-table/static-2.12769",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49954",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24120",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8174",
  "ui-addon-opt": "/ui-addon-opt/static-4.8813",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9945",
  "customer-data-rte": "/customer-data-rte/static-1.33827",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24764",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3493",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6464",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19207",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15770",
  "payment-link-components": "/payment-link-components/static-1.24367",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5533",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39104",
  "react-colorpicker": "/react-colorpicker/static-2.10642",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18521",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "user-context": "/user-context/static-1.5481",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1942",
  "atom": "/atom/static-1.5507",
  "reference-resolvers": "/reference-resolvers/static-1.8608",
  "calling-global-api": "/calling-global-api/static-1.66055",
  "calling-internal-common": "/calling-internal-common/static-1.31754",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67437",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59730",
  "commerce-products-lib": "/commerce-products-lib/static-1.10789",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4093",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4696",
  "crm-links": "/crm-links/static-1.6735",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4424",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10154",
  "external-options-client-types": "/external-options-client-types/static-1.4422",
  "formula-editor": "/formula-editor/static-1.14950",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3751",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4503",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1068",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3989",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4261",
  "property-value-citations": "/property-value-citations/static-1.3542",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8536",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.386",
  "smart-property-lib": "/smart-property-lib/static-1.8549",
  "tiered-pricing": "/tiered-pricing/static-1.2162",
  "topics-actions-lib": "/topics-actions-lib/static-1.605",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1317",
  "trial-components-library": "/trial-components-library/static-1.14306",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "laboratory-lib": "/laboratory-lib/static-3.7580",
  "onboarding-scopes": "/onboarding-scopes/static-1.6882",
  "seat-types-lib": "/seat-types-lib/static-1.968",
  "magpie-lib": "/magpie-lib/static-1.5866",
  "navigation-messaging": "/navigation-messaging/static-1.8411",
  "ts-schema": "/ts-schema/static-1.4373",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.130",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10827",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10825",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8559",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.733",
  "copilot-toolkit": "/copilot-toolkit/static-1.12068",
  "audio-components": "/audio-components/static-1.6507",
  "ContentUtils": "/ContentUtils/static-1.69377",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29993",
  "FileManagerImages": "/FileManagerImages/static-1.37915",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4571",
  "ui-universal-auth": "/ui-universal-auth/static-1.9643",
  "urlinator": "/urlinator/static-1.4946",
  "video-components": "/video-components/static-1.14357",
  "video-data-lib": "/video-data-lib/static-1.36013",
  "video-embed": "/video-embed/static-1.36847",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.767",
  "event-emitter": "/event-emitter/static-1.1391",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4303",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.441",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.575",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7227",
  "persist-promise": "/persist-promise/static-1.4133",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13597",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.353",
  "reporting-data": "/reporting-data/static-1.69223",
  "purchase-motions-components": "/purchase-motions-components/static-1.6577",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7012",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5512",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19508",
  "onboarding-tours": "/onboarding-tours/static-1.17329",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "chatspot-core": "/chatspot-core/static-1.23579",
  "content-assistance-lib": "/content-assistance-lib/static-1.8358",
  "draft-content-plugins": "/draft-content-plugins/static-1.29085",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22289",
  "rich-text-lib": "/rich-text-lib/static-1.20487",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2035",
  "poll-commands": "/poll-commands/static-1.3904",
  "video-components-external": "/video-components-external/static-1.12355",
  "trellis-story-utils": "/trellis-story-utils/static-1.4932",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9959",
  "content-media-capture": "/content-media-capture/static-1.5704",
  "knowledge-content-types": "/knowledge-content-types/static-1.8717",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10296",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9525",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10704",
  "hub-http-contrib": "/hub-http-contrib/static-1.3459",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5632",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6797",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19485",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3959",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18603",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1396",
  "calling-error-reporting": "/calling-error-reporting/static-1.31761",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11472",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6964",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2344",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "commerce-permissions": "/commerce-permissions/static-1.1210",
  "products-iframe-lib": "/products-iframe-lib/static-1.8824",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11209",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6878",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10910",
  "sales-views-client-types": "/sales-views-client-types/static-1.4688",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10340",
  "bark-lib": "/bark-lib/static-1.16961",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6318",
  "react-codemirror": "/react-codemirror/static-1.11070",
  "data-agent-kit": "/data-agent-kit/static-1.833",
  "data-token-picker": "/data-token-picker/static-1.17059",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4185",
  "policy-lib": "/policy-lib/static-1.7236",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10973",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15891",
  "hubs-service-types": "/hubs-service-types/static-1.1695",
  "navigation-components": "/navigation-components/static-1.19084",
  "nudge-client-utils": "/nudge-client-utils/static-1.3341",
  "purchase-motions-api": "/purchase-motions-api/static-1.6580",
  "signup-constants": "/signup-constants/static-1.19859",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5326",
  "reactive-lib": "/reactive-lib/static-1.1154",
  "simple-logging-lib": "/simple-logging-lib/static-1.3482",
  "nav-meta": "/nav-meta/static-1.30721",
  "cms-field-types": "/cms-field-types/static-1.5242",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17325",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1439",
  "social-insights-client-types": "/social-insights-client-types/static-1.22863",
  "outpost": "/outpost/static-1.4563",
  "reporting-client-types": "/reporting-client-types/static-1.2794",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8489",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10968",
  "immutable-less": "/immutable-less/static-1.5081",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18383",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20976",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4346",
  "growth-data-modal": "/growth-data-modal/static-1.6067",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2909",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5544",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8085",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29527",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1013",
  "breeze-engine-core": "/breeze-engine-core/static-1.1313",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13508",
  "content-media-compositions": "/content-media-compositions/static-2.17515",
  "media-bridge-lib": "/media-bridge-lib/static-1.19575",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4856",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37121",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3842",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16591",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15351",
  "nest": "/nest/static-1.666",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3098",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3417",
  "whisper-core-api": "/whisper-core-api/static-1.7563",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14740",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6042",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1157",
  "apps-service-types": "/apps-service-types/static-1.4077",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8511",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1463",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2772",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2937",
  "user-context-client": "/user-context-client/static-1.4939",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4123",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4823",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7787",
  "wootric-nps": "/wootric-nps/static-1.7274",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3439",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.686",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1803",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.207",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1254",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.415",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.782",
  "slack-ui-library": "/slack-ui-library/static-1.10827",
  "settings-ui-lib": "/settings-ui-lib/static-1.12960",
  "simple-data-table": "/simple-data-table/static-1.3753",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8046"
}
};
